import type { StyleRule } from '@archipro-design/aria';
import { swipeableEdgeSlotClassNames } from '@archipro-design/aria';
import {
    drawerSlotClassNames,
    swipeableEdgeClassName,
} from '@archipro-design/aria';
import { flexClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { popupContentSlotClassNames } from '@fluentui/react-northstar';

export const DrawerTopWrapper: StyleRule = ({ theme, isSwipeableEdge }) => ({
    [`& .${popupContentSlotClassNames.content} .${flexClassName}.${drawerSlotClassNames.content}`]:
        {
            height: 'auto',
            justifyContent: 'flex-end',
            background: isSwipeableEdge
                ? 'transparent'
                : theme.siteVariables.colors.white['FFF'],
        },

    [`& .${swipeableEdgeClassName}`]: {
        background: '#262626', // not in aria
        borderRadius: pxArrayToRem([12, 12, 0, 0]),
        [`& .${swipeableEdgeSlotClassNames.puller}`]: {
            padding: pxArrayToRem([12, 0, 25, 0]),
        },
    },
});
